module.exports = __webpack_public_path__ + "img/Bitmap.f6286633.png";